import React, { memo } from "react";

const ProgressBarDrive = ({ driveSizeCalculateData, defaultPlanStorage }) => {
  const {
    formsFileUsage,
    appointmentFileUsage,
    customerFileUsage,
    businessFileUsage,
    classFileUsage,
  } = driveSizeCalculateData;

  // Convert BusinessAccessPlan (Total) to bytes
  const Total = parseInt(defaultPlanStorage.usageLimit * 1024 * 1024);

  // Calculate the percentages for each file usage
  const FormFileWidth = ((formsFileUsage * 100) / Total).toFixed(2);
  const CustAppWidth = ((appointmentFileUsage * 100) / Total).toFixed(2);
  const CustFileWidth = ((customerFileUsage * 100) / Total).toFixed(2);
  const BusinesFileWidth = ((businessFileUsage * 100) / Total).toFixed(2);
  const ClassFileWidth = ((classFileUsage * 100) / Total).toFixed(2);

  const whiteBar = Math.max(
    (
      100 -
      (parseFloat(FormFileWidth) +
        parseFloat(CustAppWidth) +
        parseFloat(CustFileWidth) +
        parseFloat(BusinesFileWidth) +
        parseFloat(ClassFileWidth))
    ).toFixed(2),
    0
  );

  return (
    <div className="quegeplan-scale" style={{ width: "100%" }}>
      <div className="quegeplan">
        <div
          className="quegeplan6 red"
          style={{ width: `${FormFileWidth}%` }}
        ></div>
        <div
          className="quegeplan26 green"
          style={{ width: `${CustAppWidth}%` }}
        ></div>
        <div
          className="quegeplan10 drkgray"
          style={{ width: `${CustFileWidth}%` }}
        ></div>
        <div
          className="quegeplan17 drkyellow"
          style={{ width: `${BusinesFileWidth}%` }}
        ></div>
        <div
          className="quegeplan25 blue"
          style={{ width: `${ClassFileWidth}%` }}
        ></div>
        <div
          className="quegeplan18 offwhite"
          style={{ width: `${whiteBar}%` }}
        ></div>
      </div>
    </div>
  );
};

export default memo(ProgressBarDrive);
